/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react'

import * as S from './styles'

export const Separator = ({ style, width }) => (
  <S.Container style={style} width={width} />
)